import { useMemo, useState } from "react";
import { allEmoji, emojiUrl } from "@/emoji";
import { Input } from "@/components/ui/input";

export function EmojiPicker({ onPick }: { onPick: (slug: string) => void }) {
  const [q, setQ] = useState("");
  const all = allEmoji();
  const filtered = useMemo(() => {
    const f = q.trim().toLowerCase();
    if (!f) return all.slice(0, 400);
    return all.filter(
      (e) =>
        e.slug.includes(f) ||
        e.annotation.toLowerCase().includes(f) ||
        e.group.toLowerCase().includes(f) ||
        e.tags.toLowerCase().includes(f),
    );
  }, [q, all]);

  return (
    <div className="flex flex-col gap-2 h-full">
      <Input
        placeholder="Search emoji…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        autoFocus
      />
      <div className="text-xs text-muted-foreground">
        {filtered.length} of {all.length}
      </div>
      <div
        className="grid gap-1 overflow-y-auto flex-1 pr-1"
        style={{ gridTemplateColumns: "repeat(auto-fill, minmax(72px, 1fr))" }}
      >
        {filtered.map((e) => (
          <button
            key={e.slug}
            type="button"
            title={`${e.annotation} · :${e.slug}:`}
            onClick={() => onPick(e.slug)}
            className="flex flex-col items-center gap-1 rounded border border-transparent bg-muted/40 p-2 hover:border-border hover:bg-muted"
          >
            <img src={emojiUrl(e.hex)} alt={e.slug} className="h-8 w-8" loading="lazy" />
            <div className="truncate text-[9px] text-muted-foreground w-full text-center">
              {e.slug}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
